import * as React from 'react';
import {
	CheckboxGroup,
	FormCheckConditional,
	TextInput, Label
} from '../../../../../components/forms';
import handleNoneOptionAndValidationHOC from '../handleNoneOptionAndValidationHOC';
import NextPreviousButtons from '../../NextPreviousButtons';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (value?: {}) => void;
	onQuestionnaireChange: (value?: {}) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
}
const HeartAndCirculatoryQuestion: React.StatelessComponent<Props> = props => {
	const isNextDisabled = function () {
		return !props.questionnaire[questionName].isValid;
	};
	return (
		<div className="form-group mb-0">
			<Label>{props.questions[questionName]}</Label>
			<div className="section-base section-bordered mt-1 form-group">
				<CheckboxGroup
					title="Heart and circulatory system disorders, including:"
					className="mb-2"
					checkOptions={[
						{
							name: 'elevatedCholesterol',
							label: 'Elevated cholesterol or high blood pressure uncontrolled within the past 12 months',
							checked: props.questionnaire[questionName].elevatedCholesterol,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'chestPain',
							label: 'Chest pain or angina',
							checked: props.questionnaire[questionName].chestPain,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'shortnessOfBreath',
							label: 'Shortness of breath',
							checked: props.questionnaire[questionName].shortnessOfBreath,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'heartAttack',
							label: 'Heart attack (myocardial infarction)',
							checked: props.questionnaire[questionName].heartAttack,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'coronaryArteryDisease',
							label: 'Coronary artery disease or carotid artery disease',
							checked: props.questionnaire[questionName].coronaryArteryDisease,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'aneurysm',
							label: 'Aneurysm',
							checked: props.questionnaire[questionName].aneurysm,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'valvularHeartDisease',
							label: 'Valvular heart disease (e.g., mitral valve prolapse)',
							checked: props.questionnaire[questionName].valvularHeartDisease,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'cardiomyopathy',
							label: 'Cardiomyopathy',
							checked: props.questionnaire[questionName].cardiomyopathy,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'congestiveHeartFailure',
							label: 'Congestive heart failure',
							checked: props.questionnaire[questionName].congestiveHeartFailure,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'bypassOrAngioplasty',
							label: 'Bypass surgery or angioplasty',
							checked: props.questionnaire[questionName].bypassOrAngioplasty,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'abnormalECG',
							label: 'Abnormal ECG, cardiac stress test, or echocardiogram',
							checked: props.questionnaire[questionName].abnormalECG,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'irregularPulse',
							label: 'Irregular pulse',
							checked: props.questionnaire[questionName].irregularPulse,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'heartMurmur',
							label: 'Heart murmur',
							checked: props.questionnaire[questionName].heartMurmur,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'pacemaker',
							label: 'Pacemaker',
							checked: props.questionnaire[questionName].pacemaker,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'peripheralVascularDisease',
							label: 'Peripheral vascular disease',
							checked: props.questionnaire[questionName].peripheralVascularDisease,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'bloodClot',
							label: 'Blood clot, embolism or clotting disorder',
							checked: props.questionnaire[questionName].bloodClot,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'heartDisorderOther',
							label: 'Other',
							checked: props.questionnaire[questionName].heartDisorderOther,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange,
							conditionalChildren: (
								<FormCheckConditional isOpen={props.questionnaire[questionName].heartDisorderOther}>
									<TextInput
										labelText="Please specify:"
										name="heartDisorderOtherDetails"
										onBlur={props.onQuestionnaireBlur}
										onChange={props.onQuestionnaireChange}
										value={props.questionnaire[questionName].heartDisorderOtherDetails}
										className="mb-2"
									/>
								</FormCheckConditional>
							)
						},
						{
							name: `${questionName}None`,
							label: 'None of the above apply to me',
							checked: props.questionnaire[questionName][`${questionName}None`],
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange,
							className: 'border-top pt-2'
						},
					]}
				/>

			</div>
			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

const questionName = 'heartCirculatory';
const hocConfig = {
	questionName: questionName,
	otherName: 'heartDisorderOther',
	otherDetailsName: 'heartDisorderOtherDetails'
};
export default handleNoneOptionAndValidationHOC(HeartAndCirculatoryQuestion, hocConfig);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/medicalQuestions/medicalQuestion1/HeartAndCirculatoryQuestion.tsx